import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { fontSize14LineHeight } from 'approot/shared/styles/typography.style';

export const FooterSubjectsPlaceholderListItem = styled.li`
  display: flex;
  width: 100%;
  height: ${rem(fontSize14LineHeight)};
`;

export const FooterSubjectsPlaceholderLink = styled.div`
  border-radius: ${rem(4)};
  height: ${rem(fontSize14LineHeight)};
  width: ${rem(166)};
`;
